export const BATCH_SIZE = 50;
export const WINDOW_SIZE = 3 * BATCH_SIZE;